import { MRT_Localization_CS } from "mantine-react-table/locales/cs/index.cjs"
import { MRT_Localization_DE } from "mantine-react-table/locales/de/index.cjs"
import { MRT_Localization_EN } from "mantine-react-table/locales/en/index.cjs"
import { MRT_Localization_FI } from "mantine-react-table/locales/fi/index.cjs"
import { MRT_Localization_FR } from "mantine-react-table/locales/fr/index.cjs"
import { MRT_Localization_NL } from "mantine-react-table/locales/nl/index.cjs"
import { useTranslation } from "react-i18next"

export function useMrtLocalization() {
  const { i18n } = useTranslation()
  const locale = React.useMemo(
    () =>
      i18n.language === "de"
        ? MRT_Localization_DE
        : i18n.language === "cs"
          ? MRT_Localization_CS
          : i18n.language === "en"
            ? MRT_Localization_EN
            : i18n.language === "fi"
              ? MRT_Localization_FI
              : i18n.language === "fr"
                ? MRT_Localization_FR
                : i18n.language === "nl"
                  ? MRT_Localization_NL
                  : {},
    [i18n.language]
  )
  return { locale }
}
